import { render, staticRenderFns } from "./VacacionPage.vue?vue&type=template&id=1aa5bb66"
import script from "./VacacionPage.js?vue&type=script&lang=js&external"
export * from "./VacacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports